import { Component, Input, Output, SimpleChanges, OnChanges, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-generic-toggle-field',
  templateUrl: './generic-toggle-field.component.html',
  styleUrls: ['./generic-toggle-field.component.scss']
})

export class GenericToggleFieldComponent implements OnChanges {
	@Input() useId: string;
	@Input() displayName: string;
	@Input() value: boolean;
	@Input() learnMoreLink: string;
	@Input() parentFormGroup: FormGroup;
	@Input() status: any;
	@Input() isReadOnly?: boolean;
	@Output() changeState = new EventEmitter();

	constructor() {}

	// is this required?
	ngOnChanges(changes: SimpleChanges): void 
	{
		if (changes.parentFormGroup && changes.parentFormGroup.currentValue) {
			this.parentFormGroup = changes.parentFormGroup.currentValue;
		}
		if (changes.useId && changes.useId.currentValue) {
			this.useId = changes.useId.currentValue;
		}
		if (changes.displayName && changes.displayName.currentValue) {
			this.displayName = changes.displayName.currentValue;
		}
		if (changes.value !== undefined && changes.value.currentValue !== undefined) {
			this.value = changes.value.currentValue;
		}
		if (changes.learnMoreLink && changes.learnMoreLink.currentValue) {
			this.learnMoreLink = changes.learnMoreLink.currentValue;
		}
		if (changes.status && changes.status.currentValue) {
			this.status = changes.status.currentValue;
		}
		if (changes.isReadOnly && changes.isReadOnly.currentValue != undefined) {
			this.isReadOnly = changes.isReadOnly.currentValue;
			if ( this.isReadOnly == true && this.parentFormGroup )
				this.parentFormGroup.controls[this.useId].disable();
			else if ( this.isReadOnly == false && this.parentFormGroup )
				this.parentFormGroup.controls[this.useId].enable();
		}
	}

	updateState( event )
	{
		this.value = !this.value;
		this.changeState.emit( {event: event, value: this.value} );
	}

	onLearnMore()
	{
		window.open( this.learnMoreLink );
	}
}
